// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navHead {
    color: teal;
    font-size: 20px;
    font-weight: bold;
}

.info {
    font-size: 13px;
}

.cursorPointer {
    cursor: pointer;
}

.cardImage{
    background: url('my_reports.jpg') no-repeat 0 0;
    height: auto;
    width: 50%;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 80px;    
}

.cardHeader{
    height: 80px;
    margin-bottom: 0px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm9wcy1yZXBvcnQtaG9tZS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksV0FBVztJQUNYLGVBQWU7SUFDZixpQkFBaUI7QUFDckI7O0FBRUE7SUFDSSxlQUFlO0FBQ25COztBQUVBO0lBQ0ksZUFBZTtBQUNuQjs7QUFFQTtJQUNJLCtDQUE4RTtJQUM5RSxZQUFZO0lBQ1osVUFBVTtJQUNWLGlCQUFpQjtJQUNqQixrQkFBa0I7SUFDbEIsb0JBQW9CO0FBQ3hCOztBQUVBO0lBQ0ksWUFBWTtJQUNaLGtCQUFrQjtBQUN0QiIsImZpbGUiOiJvcHMtcmVwb3J0LWhvbWUuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5uYXZIZWFkIHtcclxuICAgIGNvbG9yOiB0ZWFsO1xyXG4gICAgZm9udC1zaXplOiAyMHB4O1xyXG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XHJcbn1cclxuXHJcbi5pbmZvIHtcclxuICAgIGZvbnQtc2l6ZTogMTNweDtcclxufVxyXG5cclxuLmN1cnNvclBvaW50ZXIge1xyXG4gICAgY3Vyc29yOiBwb2ludGVyO1xyXG59XHJcblxyXG4uY2FyZEltYWdle1xyXG4gICAgYmFja2dyb3VuZDogdXJsKCdzcmMvYXNzZXRzL2ltYWdlL2FjdGlvbnNJbWFnZXMvbXlfcmVwb3J0cy5qcGcnKSBuby1yZXBlYXQgMCAwO1xyXG4gICAgaGVpZ2h0OiBhdXRvO1xyXG4gICAgd2lkdGg6IDUwJTtcclxuICAgIG1hcmdpbi1sZWZ0OiBhdXRvO1xyXG4gICAgbWFyZ2luLXJpZ2h0OiBhdXRvO1xyXG4gICAgcGFkZGluZy1ib3R0b206IDgwcHg7ICAgIFxyXG59XHJcblxyXG4uY2FyZEhlYWRlcntcclxuICAgIGhlaWdodDogODBweDtcclxuICAgIG1hcmdpbi1ib3R0b206IDBweDtcclxufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/View/core/reports/ops-report-home/ops-report-home.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,+CAA8E;IAC9E,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA,opCAAopC","sourcesContent":[".navHead {\r\n    color: teal;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n}\r\n\r\n.info {\r\n    font-size: 13px;\r\n}\r\n\r\n.cursorPointer {\r\n    cursor: pointer;\r\n}\r\n\r\n.cardImage{\r\n    background: url('src/assets/image/actionsImages/my_reports.jpg') no-repeat 0 0;\r\n    height: auto;\r\n    width: 50%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    padding-bottom: 80px;    \r\n}\r\n\r\n.cardHeader{\r\n    height: 80px;\r\n    margin-bottom: 0px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
